const storefrontAccessToken = '9a7b2039a1e9b3b94d07b4d008961cfd';
const shopDomain = 'letscomtr.myshopify.com';

document.addEventListener('DOMContentLoaded', () => {
  
  // --- KAYIT OLMA (REGISTER) ---
  const regBtn = document.getElementById('register-submit');
  if (regBtn) {
    regBtn.addEventListener('click', async () => {
      const firstName = document.getElementById('reg-firstname').value;
      const lastName = document.getElementById('reg-lastname').value;
      const email = document.getElementById('reg-email').value;
      const password = document.getElementById('reg-password').value;
      const errorEl = document.getElementById('reg-error');
      const successEl = document.getElementById('reg-success');

      if (!email || !password) {
        errorEl.innerText = "Lütfen tüm alanları doldurun.";
        errorEl.style.display = 'block';
        return;
      }

      const registerQuery = `
        mutation customerCreate($input: CustomerCreateInput!) {
          customerCreate(input: $input) {
            customer { id }
            customerUserErrors { message }
          }
        }
      `;

      try {
        const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
          body: JSON.stringify({ query: registerQuery, variables: { input: { firstName, lastName, email, password } } }),
        });

        const result = await response.json();
        const data = result.data.customerCreate;

        if (data.customer) {
          successEl.innerText = "Hesap başarıyla oluşturuldu! Şimdi giriş yapabilirsiniz.";
          successEl.style.display = 'block';
          errorEl.style.display = 'none';
        } else {
          errorEl.innerText = data.customerUserErrors[0].message;
          errorEl.style.display = 'block';
        }
      } catch (err) {
        console.error('Kayıt hatası:', err);
      }
    });
  }

  // --- GİRİŞ YAPMA (LOGIN) ---
  const loginBtn = document.getElementById('login-submit');
  if (loginBtn) {
    loginBtn.addEventListener('click', async () => {
      const email = document.getElementById('login-email').value;
      const password = document.getElementById('login-password').value;
      const errorEl = document.getElementById('login-error');

      const loginQuery = `
        mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
          customerAccessTokenCreate(input: $input) {
            customerAccessToken { accessToken }
            customerUserErrors { message }
          }
        }
      `;

      try {
        const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
          body: JSON.stringify({ query: loginQuery, variables: { input: { email, password } } }),
        });

        const result = await response.json();
        const data = result.data.customerAccessTokenCreate;

        if (data.customerAccessToken) {
          // Başarılıysa Liquid formunu gönder (CAPTCHA korumasını aşmak için en iyisi)
          document.getElementById('hidden-login-form').submit();
        } else {
          errorEl.innerText = "E-posta veya şifre hatalı.";
          errorEl.style.display = 'block';
        }
      } catch (err) {
        console.error('Login hatası:', err);
      }
    });
  }
});